export const RSAContentText = `We will issue your policy schedule along with other \
related documents in the post, you can expect to receive these in the \
coming days.`;

export const ChubbContentText = `We'll email you when your policy is ready. You can \
view your welcome documents pack now`;

export const registrationPrompt = `To access your policy documents you will need \
to ensure that you register your account, please select the 'register now' \
option below, alternatively we have emailed you the relevant link. `;

export const contentTexts = {
  car: RSAContentText,
  travel: ChubbContentText
};
